<template>
  <div class="content">
    <!-- <div class="Join-btn">
      <ul>
        <li
          v-for="(item,index) in title"
          :key="index"
          @click="addClass(index,item)"
          v-bind:class="{classred:index==current}"
        >{{item.name}}</li>
      </ul>
    </div>-->
    <div class="subfoor" v-if="show">
      <div class="Join-btns">
      <div>我要加盟,提交资料我们会第一时间与您联系</div>
      <div class="tels">招商经理电话/微信: 15959374622</div>
      </div>
      <div class="subfoor-main">
        <div class="subfoor-one">
          <div class="subfoor-left">
            <el-input v-model="partnerName" placeholder="请输入姓名" ></el-input>
          </div>
          <div class="subfoor-right">
            <el-input v-model="moblephone" placeholder="请输入手机号码"></el-input>
          </div>
        </div>
        <div class="subfoor-one">
          <div class="subfoor-left">
            <VDistpicker
              :province="joinProvince"
              :city="joinCity"
              :area="county"
              @province="onChangeProvince"
              @city="onChangeCity"
              @area="onChangearea"
            ></VDistpicker>
          </div>
          <div class="subfoor-right">
            <el-input type="textarea" :rows="2" placeholder="请输入备注内容" v-model="remark"></el-input>
          </div>
        </div>
        <!-- <div class="subfoor-one">
          <div class="subfoor-left2">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="remark"></el-input>
          </div>
        </div>-->
        <div style="margin-bottom:20px;margin-top:7px;">
          <el-button @click="subst" :disabled="disabled">提交</el-button>
        </div>
      </div>
    </div>
    <div class="subfoor" v-if="!show">
      <div class="Join-btns">我是厂家</div>
      <div class="subfoor-main">
        <div class="subfoor-one">
          <div class="subfoor-left">
            <el-input v-model="vendername" placeholder="请输入厂家名"></el-input>
          </div>
          <div class="subfoor-right">
            <el-input v-model="linkman" placeholder="请输入联系人姓名"></el-input>
          </div>
        </div>
        <div class="subfoor-one">
          <div class="subfoor-left">
            <el-input v-model="moblephone2" placeholder="请输入手机号码"></el-input>
          </div>
          <div class="subfoor-right">
            <el-input v-model="supplytype" placeholder="请输入所需产品"></el-input>
          </div>
        </div>
        <div class="subfoor-one">
          <div class="subfoor-left">
            <VDistpicker
              :province="venderprovince"
              :city="vendercity"
              :area="county2"
              @province="onChangeProvince2"
              @city="onChangeCity2"
              @area="onChangearea2"
            ></VDistpicker>
          </div>
          <!-- <div class="subfoor-right">
            <span class="panleft">城市:</span>
            <el-select v-model="vendercity" placeholder="请选择城市">
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>-->
        </div>
        <div class="subfoor-one">
          <div class="subfoor-left2">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="remark2"></el-input>
          </div>
        </div>
        <div style="margin-bottom:20px;margin-top:20px;">
          <el-button @click="subjoin" :disabled="disabled">提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import VDistpicker from "v-distpicker";
export default {
  components: {
    VDistpicker
  },
  props: ["kefshow"],
  watch: {
    kefshow: "getkefshow"
  },
  data() {
    return {
      title: [{ name: "我要加盟" }, { name: "我是厂家" }],
      current: 0,
      input: "",
      textarea: "",
      show: true,
      joinProvince: "",
      joinCity: "",
      county: "",
      partnerName: "",
      moblephone: "",
      remark: "",
      source: "2",
      linkman: "",
      moblephone2: "",
      remark2: "",
      supplytype: "",
      vendercity: "",
      vendername: "",
      venderprovince: "",
      county2: "",
      disabled: false,
      code:"",
      codes:""
    };
  },
  methods: {
    getkefshow() {
      //console.log("this.kefshow", this.kefshow);
      if (this.kefshow == 2) {
        this.show = false;
      } else {
        this.show = true;
      }
    },
    addClass(index, item) {
      this.current = index;
      //console.log("this.current", this.current);
      this.$emit("showjm", this.current);
      if (this.current == 0) {
        this.show = true;
      } else {
        this.show = false;
      }
    },
    onChangeProvince(data) {
      this.joinProvince = data.value;
    },
    onChangeCity(data) {
      this.joinCity = data.value;
    },
    onChangearea(data) {
      this.county = data.value;
    },
    onChangeProvince2(data) {
      this.venderprovince = data.value;
    },
    onChangeCity2(data) {
      this.vendercity = data.value;
    },
    onChangearea2(data) {
      this.county2 = data.value;
    },
    subst: async function() {
      if (this.partnerName == "") {
        this.$message({
          message: "姓名不能为空",
          offset:"400",
          type: "warning",
          
        });
        return false;
      }
       if (this.moblephone == "") {
        this.$message({
          message: "电话不能为空",
          offset:"400",
          type: "warning"
        });
        return false;
      }
      if (this.joinProvince == "") {
        this.$message({
          message: "省份不能为空",
          offset:"400",
          type: "warning"
        });
        return false;
      }
      if (this.joinCity == "") {
        this.$message({
          message: "市级不能为空",
          offset:"400",
          type: "warning"
        });
        return false;
      }
      if (this.county == "") {
        this.$message({
          message: "区/县不能为空",
          offset:"400",
          type: "warning"
        });
        return false;
      }
      if (/^1[3-9]\d{9}$/.test(this.moblephone) == false ) {
        this.$message({
          message: "电话号码格式不正确",
          offset:"400",
          type: "warning"
        });
        return false;
      }
      let data = {
        joinProvince: this.joinProvince,
        joinCity: this.joinCity,
        county: this.county,
        partnerName: this.partnerName,
        moblephone: this.moblephone,
        remark: this.remark,
        source: "1"
      };
      const res = await this.exequy.Submission(data);
      this.code=res.data.code;
      this.$emit('childFn', this.code);
      // console.log("8989",this.code)
      if (res.data.msg == "success") {
        this.$message({
          message: "提交成功,我们会于三个工作日内与您联系",
          offset:"400",
          type: "success"
        });
        this.disabled = true;
      }
    },
    subjoin: async function() {
      if (this.vendername == "") {
        this.$message({
          message: "厂家不能为空",
          offset:"400",
          type: "warning"
        });
        return false;
      }
      if (this.linkman == "") {
        this.$message({
          message: "联系人不能为空",
          offset:"400",
          type: "warning"
        });
        return false;
      }
      if (this.moblephone2 == "") {
        this.$message({
          message: "电话号码不能为空",
          offset:"400",
          type: "warning"
        });
         return false;
      }
      if (this.supplytype == "") {
        this.$message({
          message: "请输入所需产品",
          offset:"400",
          type: "warning"
        });
         return false;
      }
      if (this.venderprovince == "") {
        this.$message({
          message: "省份不能为空",
          offset:"400",
          type: "warning"
        });
        return false;
      }
      if (this.vendercity == "") {
        this.$message({
          message: "市级不能为空",
          offset:"400",
          type: "warning"
        });
        return false;
      }
      if (this.county2 == "") {
        this.$message({
          message: "区/县不能为空",
          offset:"400",
          type: "warning"
        });
        return false;
      }
      if (this.remark2 == "") {
        this.$message({
          message: "请输入具体内容",
          offset:"400",
          type: "warning"
        });
        return false;
      }
      if (/^1[3-9]\d{9}$/.test(this.moblephone2) == false ) {
        this.$message({
          message: "电话号码格式不正确",
          offset:"400",
          type: "warning"
        });
         return false;
      }
      let data = {
        linkman: this.linkman,
        moblephone: this.moblephone2,
        remark: this.remark2,
        county: this.county2,
        supplytype: this.supplytype,
        vendercity: this.vendercity,
        vendername: this.vendername,
        venderprovince: this.venderprovince,
        source: "1"
      };
      const res = await this.exequy.Manufacturers(data);
      this.codes=res.data.code;
      this.$emit('childFns', this.codes);
      if (res.data.msg == "success") {
        this.$message({
          message: "提交成功,我们会于三个工作日内与您联系",
          offset:"400",
          type: "success"
        });
        this.disabled = true;
      }
    }
  },
  created: async function() {
    let self = this;
    self.getkefshow();
  }
};
</script>
<style scoped>
.content {
  width: 100%;
}
.classred {
  color: #fff;
  background: #b31d25;
}
.Join-btn {
  width: 300px;
  height: 3rem;
  display: flex;
  align-items: center;
  font-size: 14px;
  margin: 0 auto;
  margin-top: 20px;
}
.Join-btn ul {
  overflow: hidden;
  padding-inline-start: 0px;
}
.Join-btn ul li {
  list-style: none;
  width: 150px;
  height: 33px;
  float: left;
  line-height: 33px;
  border-radius: 8px;
}
.panleft {
  padding-left: 20px;
}
.el-input {
  width: 80%;
  display: block;
  margin: 0 auto;
  margin-top: 2rem;
}
.subfoor{
  overflow: hidden;
}
.subfoor-main {
  width: 80%;
  margin: 0 auto;
}
.subfoor-main >>> .el-button--default {
  width: 150px;
  background: #b31d25;
  color: #fff;
}
.subfoor-one {
  width: 100%;
  overflow: hidden;
}
.subfoor-left {
  width: 100%;
  /* float: left;
  text-align: left; */
}
.subfoor-right {
  width: 100%;
  float: left;
  text-align: left;
}
.subfoor-left2 {
  width: 100%;
  float: left;
  text-align: left;
  /* line-height: 70px; */
}
.el-textarea {
  width: 80%;
  height: 70px;
  display: block;
  margin: 0 auto;
  margin-top: 2rem;
}
.subfoor-left2 >>> .el-textarea__inner {
  height: 70px;
}
.el-select {
  width: 80%;
  float: left;
}
.distpicker-address-wrapper >>> select {
  width: 26.5%;
  margin: 0 auto;
  /* display: block; */
  margin-top: 2rem;
}
.distpicker-address-wrapper >>> select:nth-child(n + 2) {
  margin-top: 2rem;
}
.textarea {
  height: 70px;
}
.Join-btns {
      font-size: 16px;
    color: #fff;
    height: 1rem;
    text-align: center;
    margin-top: 10px;
}
.tels{
  font-size: 12px;
  text-align: center;
}
</style>
